import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './stile/global.css'

// Der Abfrage-Zwischenspeicher haelt Serverdaten vor. Wichtig fuer die Erfassung vor Ort:
// nach jeder Aenderung wird neu geladen, damit nie ein veralteter Stand angezeigt wird.
const abfrageClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
  },
})

createRoot(document.getElementById('wurzel')!).render(
  <StrictMode>
    <QueryClientProvider client={abfrageClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
